/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель текущего города
   */
  app.SettlementForm = app.Model.extend({
    currentSettlementId: null,
    customsUnionCountries: ['AM', 'BY', 'KZ', 'KG'],
    additionalOptions: ['user', 'requestParameters', 'needSave'],
    urlRoot: app.entryScriptName + '/api/v3/settlement-form',
    needSave: false,
    isUpdating: false,

    /**
     * @inheritDoc
     */
    run: function () {
      this.expand = 'expand=has_active_jp_purchase,jp_request_min_sum';
      this.listenTo(
        Backbone,
        app.CQC_COMMANDS_TYPES_TO_EVENTS[app.CQC_COMMAND_TYPES.settlementUpdate],
        this.initUpdating.bind(this, this.update, true)
      );
      this.listenTo(
        Backbone,
        app.CQC_COMMANDS_TYPES_TO_EVENTS[app.CQC_COMMAND_TYPES.districtUpdate],
        this.initUpdating.bind(this, this.updateDistrictId, false)
      );
      this.listenTo(
        Backbone,
        app.CQC_COMMANDS_TYPES_TO_EVENTS[app.CQC_COMMAND_TYPES.currencyUpdate],
        this.initUpdating.bind(this, this.updateCurrency, true)
      );
      this.listenTo(
        this,
        'sync',
        this.handleDoneUpdating
      );
      this.listenTo(
        Backbone,
        'sync',
        this.handleDoneUpdating
      );
    },

    /**
     * Меняет статус "isUpdating" на false.
     */
    handleDoneUpdating: function() {
      var that = this;

      // Таймаут используется потому что статус "isUpdating" нужно изменять только после того,
      // как стек вызовов освободится
      setTimeout(function() {
        that.isUpdating = false;
      }, 1);
    },

    /**
     * Инициализрует запуск обновления по переданной функции
     * @param {Function} fn Функция, выполняющая обновления
     * @param {Function} needToggleDone Необходимо ли переключить флаг загрузки данных
     * @param {Object} data Данные, передаваемые в функцию
     */
    initUpdating: function(fn, needToggleDone, data) {
      var that = this;
      if(!that.isUpdating) {
        that.isUpdating = true;

        fn.call(that, data);
        needToggleDone && that.handleDoneUpdating();
      } else {
        var intervalId = setInterval(function() {
          if(!that.isUpdating) {
            clearInterval(intervalId);
            that.initUpdating.call(that, fn, needToggleDone, data);
          }
        }, 10);
      }
    },

    /**
     * Добавляет обработчик синхронизации
     */
    attachOnSyncHandler: function () {
      this.listenTo(this, 'sync', this.onSync);
    },

    /**
     * Выполняется при синхронизации модели
     * @param {app.SettlementForm} model - модель после синхронизации
     */
    onSync: function (model) {
      var newSettlementId = model.get('settlement_id');
      if (newSettlementId !== this.currentSettlementId) {
        this.currentSettlementId = newSettlementId;
        Backbone.trigger(app.CQC_COMMAND_EVENT, {
          type: app.CQC_COMMAND_TYPES.settlementUpdate,
          settlement: {
            id: this.currentSettlementId,
            name: model.get('name'),
            region: model.get('region'),
            contact_phone: model.get('phone'),
            shipping_time: [
              model.get('min_date'),
              model.get('max_date'),
            ],
            districts: model.get('districts') || [],
            has_active_jp_purchase: model.get('has_active_jp_purchase'),
          },
        });
      }
    },

    /**
     * Обновление атрибутов новыми данными
     * @param {Object} data - данные
     */
    update: function (data) {
      var newSettlement = data.settlement;
      if (newSettlement.id !== this.currentSettlementId) {
        this.currentSettlementId = newSettlement.id;
        if (this.needSave) {
          this.save(
            { settlement_id: newSettlement.id },
            {
              success: function () {
                app.helpers.OkoHelper.updateOkoInfo(newSettlement);
              }
            }
          );
        } else {
          var shippingTime = newSettlement.shipping_time || [];
          this.set({
            settlement_id: newSettlement.id,
            district_id: newSettlement.district ? newSettlement.district.id : null,
            name: newSettlement.name,
            region: newSettlement.region,
            phone: newSettlement.contact_phone,
            min_date: shippingTime[0] || null,
            max_date: shippingTime[1] || null,
          });
          app.helpers.OkoHelper.updateOkoInfo(newSettlement);
          if (app.districts) {
            Backbone.trigger('reset-districts', newSettlement.districts);
            Backbone.trigger('change-city-signup', this, app.districts);
          }
          this.trigger('sync', this, this.toJSON());
        }
      }
    },

    /**
     * Обновление атрибута district_id
     * @param {Object} data Данные с новым районом
     */
    updateDistrictId: function (data) {
      var newDistrict = data.district;
      var lastDistrictId = this.get('district_id');
      var isDistrictsNotEqual = newDistrict && newDistrict.id !== lastDistrictId;
      var isNewDistrictInCurrentCity = newDistrict && newDistrict.settlement_id === this.get('settlement_id');
      if (
        (
          isDistrictsNotEqual
          && isNewDistrictInCurrentCity
        )
        || newDistrict === null
      ) {
        this.set({
          district_id: newDistrict ? newDistrict.id : null,
        });
        if (newDistrict === null && lastDistrictId === null) {
          this.trigger('change:district_id');
        }
        this.trigger('sync', this, this.toJSON());
        if (app.districts) {
          Backbone.trigger('change-city-signup', this, app.districts);
        }
      } else {
        this.handleDoneUpdating();
      }
    },

    /**
     * Обновление аттрибута currency
     * @param {object} command Данные с новой валютой
     */
    updateCurrency: function(command) {
      if (this.needSave) {
        this.save({
          currency: command.currency,
        });
      }
    },


    attachMinSumTrigger: function () {
      this.listenTo(this, 'sync', function (model) {
        Backbone.trigger('minSumUpdated', model);
      });
    },

    /**
     * Возвращает true, если город в России
     * @returns {boolean}
     */
    isRussia: function () {
      return this.get('country') === 'RU';
    },

    /**
     * Показывать шильдики товаров партнеров и попап заказа
     * @returns {boolean}
     */
    isRemoteStoreEnabled: function () {
      return ['RU', 'KZ', 'BY'].indexOf(this.get('country')) !== -1 && !this.get('is_small_wholesale');
    },
  });
})();

}.call(window));